import axios from "axios";
import { toast } from "sonner";

export const http = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const roleLabels = {
  admin: "Administrator",
  sub_admin: "Sub-Admin",
  business_head: "Business Head",
  sales_manager: "Sales Manager",
  telecaller: "Sales Associate",
  back_office_manager: "Back Office Manager",
  back_office_executive: "Back Office Executive",
};

export const defaultStatuses = [
  "New", "Contact Pending", "Contacted", "Interested", "Documents Pending",
  "Documents Received", "Eligibility Check", "Application Ready",
  "Submitted to Bank/NBFC", "Login Done", "Processing", "Query Raised",
  "Approved", "Rejected", "Disbursed", "Closed", "Not Interested",
  "Not Eligible", "Duplicate",
];

export const loanTypes = [
  "Personal Loan", "Home Loan", "Loan Against Property",
  "Car Loan", "Business Loan", "Other",
];

/**
 * Mask a mobile number for list / dashboard views.
 * Rules: keep first 2 and last 2 digits; replace the middle with 'X'.
 * Shorter than 4 digits → fully redacted to '****'.
 * The mask is applied only in list contexts — the detail page shows
 * the raw value coming back from the CRM API.
 */
export function maskMobile(value) {
  if (value == null) return "";
  const digits = String(value).replace(/\D/g, "");
  if (digits.length < 4) return "****";
  return `${digits.slice(0, 2)}${"X".repeat(digits.length - 4)}${digits.slice(-2)}`;
}

export const documentTypes = [
  "PAN", "Aadhaar", "Address proof", "Income proof", "Salary slips",
  "Bank statement", "Employment letter", "Property documents",
  "Vehicle documents", "Other",
];

export const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const errorMessage = (err) => {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object") {
    // Structured errors (e.g. 409 duplicate-lead) — surface the human message
    // and any actionable id the server included.
    if (detail.message) {
      const extra = detail.existing_lead_id ? ` · Existing lead: ${detail.existing_lead_id}` : "";
      return detail.message + extra;
    }
    try { return JSON.stringify(detail); } catch { /* fall through */ }
  }
  return detail || err?.message || "Something went wrong. Please try again.";
};

export const notify = {
  success: (message) => toast.success(message, { duration: 3000 }),
  error: (err, fallback = "Something went wrong") => {
    const message = typeof err === "string" ? err : errorMessage(err);
    toast.error(message || fallback, { duration: 4500 });
  },
  info: (message) => toast(message, { duration: 3000 }),
};

export const can = (user, permission) =>
  user?.role === "admin" || (user?.permissions || []).includes(permission);
